export interface SkillTag {
  id: number | null;
  tag: string;
}

export interface navMenuList {
  id: number;
  label: string;
  questionType?: string;
}

export enum LogEvents {
  TABCHANGE = 'TAB_CHANGED',
  BACK_IN_TAB = 'BACK_IN_TAB',
  TEXTCOPY = 'TEXT_COPIED',
  FULLSCREEN = 'FULL_SCREEN_CLOSED',
  BACK_IN_VIEW = 'BACK_IN_VIEW',
  OUT_OF_VIEW = 'OUT_OF_VIEW',
  EYE_VIEW_RESTORED = 'EYE_VIEW_RESTORED',
  EYE_VIEW_DEVIATION = 'EYE_VIEW_DEVIATION',
  TAB_SWITCHED = 'TAB_SWITCHED',
  CODE_PASTED = 'CODE_PASTED',
  MESH_INITIATED = 'MESH_INITIATED',
}

export enum VideoErrorType {
  NF = 'NotFoundError',
  NA = 'NotAllowedError',
  NR = 'NotReadableError',
  AB = 'AbortError',
}
